var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 206,
    viewBox: "0 0 250 206",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.354%",
    y1: "36.07%",
    x2: "-1.78%",
    y2: "52.227%",
    id: "gjo563sxnc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC902",
    stopOpacity: 0.422,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD7CB",
    stopOpacity: 0.06,
    offset: "47.897%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.502%",
    y1: "21.929%",
    x2: "-68.523%",
    y2: "71.45%",
    id: "guvktifu8e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0171B7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.964%",
    y1: "83.424%",
    x2: "122.925%",
    y2: "-35.527%",
    id: "o5afrd3w3f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7DA4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427693",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-146.313%",
    y1: "160.95%",
    x2: "100%",
    y2: "11.691%",
    id: "5h0bw70ofi"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0171B7",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065182",
    stopOpacity: 0.982,
    offset: "42.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0171B7",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.638%",
    y1: "65.681%",
    x2: "81.579%",
    y2: "-54.786%",
    id: "rirtefe4tl"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F8",
    stopOpacity: 0.428,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0171B7",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.693%",
    y1: "45.088%",
    x2: "-13.715%",
    y2: "54.932%",
    id: "5b7gynu30o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD0E4",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0171B7",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.654%",
    y1: "30.925%",
    x2: "-16.768%",
    y2: "67.459%",
    id: "0hpbud90tp"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.087,
    offset: "6.339%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.083,
    offset: "7.447%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1FAFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "56.737%",
    y2: "140.712%",
    id: "twjiefv15q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588FAF",
    stopOpacity: 0.115,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#045183",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "49.204%",
    y2: "117.946%",
    id: "wx8rcob0wr"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588FAF",
    stopOpacity: 0.115,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#045183",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "22.585%",
    x2: "139.745%",
    y2: "131.006%",
    id: "34yxyptqrs"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588FAF",
    stopOpacity: 0.115,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#045183",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.848%",
    y1: "44.392%",
    x2: "133.62%",
    y2: "32.315%",
    id: "dfubdgel7t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588FAF",
    stopOpacity: 0.115,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#045183",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "t2szt0xi2a",
    d: "M0 0h250v206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 33.269 26.174 20.894 1.167 23.745a1 1 0 0 0 1.665.696L44.74 64.55l27.84 22.57L112.734 0l-1.666.492L0 33.269z",
    id: "n6wq8p16ld"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3npzrczu9h",
    d: "m259.58 64.694-2.795-16.096 58.28-36.728z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vmqfr2fhkk",
    d: "m278.713 97.573-8.384-42.32 48.363-44.634z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y465lnf8in",
    d: "m203.133 49.087 52.405 3.7 58.165-36.436z"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-9.5%",
    width: "124%",
    height: "126.5%",
    filterUnits: "objectBoundingBox",
    id: "nh8iegugsg"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.291093306 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-5.8%",
    width: "128.9%",
    height: "116.1%",
    filterUnits: "objectBoundingBox",
    id: "xiluw9zioj"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.291093306 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-8.1%",
    y: "-13.7%",
    width: "112.7%",
    height: "138.4%",
    filterUnits: "objectBoundingBox",
    id: "k6ygcjz03m"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.291093306 0",
    "in": "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yoj2h9h84b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t2szt0xi2a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#yoj2h9h84b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.953 127.919 142.136 38.303c49.676 13.387 101.286-13.722 118.455-62.221l28.902-81.645a2 2 0 0 0-2.671-2.507l-50.688 21.667c76.198-8.827 38.339 1.307-113.577 30.404C-2.407 101.016-34.034 84.595 54.627 22.655L26.953 127.92z",
    fill: "url(#gjo563sxnc)",
    transform: "rotate(-4 352.697 1205.465)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#guvktifu8e)",
    xlinkHref: "#n6wq8p16ld",
    transform: "rotate(-9 321.32 -767.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.174 54.163 1.167 23.745a1 1 0 0 0 1.665.697l7.686-6.864 7.313-6.531 12.02-12.118-2.794-16.096-27.057 17.167z",
    fill: "url(#o5afrd3w3f)",
    opacity: 0.705,
    transform: "rotate(-9 321.32 -767.54)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.705,
    transform: "rotate(-9 349.39 531.463)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#nh8iegugsg)",
    xlinkHref: "#3npzrczu9h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#5h0bw70ofi)",
    xlinkHref: "#3npzrczu9h"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9 357.975 547.278)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#xiluw9zioj)",
    xlinkHref: "#vmqfr2fhkk"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#rirtefe4tl)",
    xlinkHref: "#vmqfr2fhkk"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9 321.883 527.75)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#k6ygcjz03m)",
    xlinkHref: "#y465lnf8in"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#5b7gynu30o)",
    xlinkHref: "#y465lnf8in"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m316.515 13.671-86.549 54.17-.696-.553 84.372-52.33a11.802 11.802 0 0 1 2.873-1.287z",
    fill: "url(#0hpbud90tp)",
    fillRule: "nonzero",
    transform: "rotate(-9 336.357 533.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.083 78.939-.57-11.253 8.264 5.11a1 1 0 0 0 1.509-.665l3.786-20.162 5.833 3.648-2.871 20.938-2.333 9.743a1 1 0 0 1-1.522.603l-12.096-7.962z",
    fill: "url(#twjiefv15q)",
    transform: "rotate(-141 215.858 91.349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.295 36.59.06-19.654.065-21.651 12.665 9.812-5.886 34.364-5.902 34.26-1.002-37.1a1 1 0 0 1 0-.03z",
    fill: "url(#wx8rcob0wr)",
    transform: "rotate(-141 247.338 56.025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.936 73.243 4.984-.991 22.716 12.234a1 1 0 0 0 1.474-.907l-.399-14.599 6.938-1.282.962 16.053.696 11.62-37.371-22.128z",
    fill: "url(#34yxyptqrs)",
    transform: "rotate(-141 241.27 103.056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.895 62.13 23.792-15.664a1 1 0 0 0-.728-1.82l-17.301 3.134 2.554-7.161 31.554 1.077-43.454 29.288 3.583-8.853z",
    fill: "url(#dfubdgel7t)",
    transform: "scale(1 -1) rotate(39 374.025 -115.83)"
  })))));
};
export default SvgSuccess;